// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"41239196","952":"da40921d"}[chunkId] + ".chunk.js";
};